import './Leaderboard.css';

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import useSession from '../../hooks/useSession';
import { getWithAuth } from '../../utils/api';

import Menu from '../../components/HamburgerMenu';
import FPOImage from '../../components/FPOImage';
import FPO_IMAGE from './Leaderboard_Fullscreen_2x.png';

const FPO_OUTLINE = false;

function Leaderboard() {
  const navigate = useNavigate();
  const { session } = useSession();

  const [userRank, setUserRank] = React.useState(null);
  const [leaderboard, setLeaderboard] = React.useState([]);

  useEffect(() => {
    const getLeaderBoard = async (_session) => {
      try {
        const url = `/sessions/aggregate?reducer=sum`;
        const res = await getWithAuth(url, _session.authToken);
        const data = await res.json();
        if (!res.ok) {
          throw new Error(data?.message || 'Request failed');
        }

        const rank = data.findIndex(entry => entry.userId === _session.id) + 1;
        if (rank > 0) {
          setUserRank(rank);
        }
        setLeaderboard(data.slice(0, 10));
      } catch (error) {
        setUserRank(null);
        setLeaderboard([]);
      }
    }

    if (!session) {
      navigate('/');
    } else {
      getLeaderBoard(session);
    }
  }, [session, navigate]);

  return (
    <div className='page'>
      <Menu />
      <FPOImage
        src={FPO_IMAGE}
        height={125}
        offset={0}
        alt="Amazon Ads"
        isOutlined={FPO_OUTLINE}
      />
      <FPOImage
        src={FPO_IMAGE}
        height={70}
        offset={0 - 125}
        alt="Leaderboard Title"
        isOutlined={FPO_OUTLINE}
      />

      {userRank !== null && session && (
        <section className='leaderboard-intro'>
          <p>
            <strong>{session.display},</strong>
            <span>{' '}you are ranked{' '}</span>
            <strong>#{userRank}</strong>
            <span>{' '}right now.</span>
          </p>
        </section>
      )}

      <FPOImage
        src={FPO_IMAGE}
        height={550}
        offset={0 - 125 - 100 - 250}
        alt="About Your Score"
        isOutlined={FPO_OUTLINE}
      />
      
      <section className='leaderboard-list'>
        <div className='expand-background' />
        {leaderboard.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>Rank</th>
                <th>Username</th>
                <th>Star Points</th>
              </tr>
            </thead>
            <tbody>
              {leaderboard.map((entry, index) => {
                let isCurrentUser = session && entry.userId === session.id;
                return (
                  <tr key={entry.userId} className={isCurrentUser ? 'current-user' : ''}>
                    <td className='rank'>{index + 1}</td>
                    <td className='username'>{entry.username || 'Anonymous'}{isCurrentUser ? <span className='you-callout'>{' 🤩'}</span> : ''}</td>
                    <td className='score'>{entry.result || 0}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        ) : (
          <p className="loading">Loading leaderboard...</p>
        )}
      </section>

      <FPOImage
        src={FPO_IMAGE}
        height={500}
        offset={0 - 125 - 100 - 250 - 550 - 1120}
        alt="About Your Score"
        isOutlined={FPO_OUTLINE}
      />
    </div>
  );
}


export default Leaderboard;
